module.exports = __webpack_public_path__ + "static/img/1050_small.046eaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1050_small.png
// module id = SEz9
// module chunks = 1